import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
  postRequestForm,
  patchRequestForm,
} from "./api";
import {
  USER_LOGIN,
  FORGOT_PASSWORD,
  SEND_OTP,
  VERIFY_OTP,
  RESET_PASSWORD,
  GET_ALL_POSTS,
  GET_TIME_FOR_POSTS,
  GET_POST_BY_ID,
  EDIT_UNIVERSITY,
  GET_USER_EVENT,
  DELETE_EVENT,
  DELETE_POST,
  GET_STORIES,
  OFFICIAL_COMMUNITY,
  GET_USER,
  BOOSTED_POST,
  BOOSTED_EVENT,
  BOOSTED_STORIES,
  CUSTOM_COMMUNITY,
  DELETE_STORY,
  DELETE_COMMUNITY,
  USER_CHANGE_STATUS,
  SEACRH_USER,
  GET_USER_PROFILE,
  UPDATE_USER_PROFILE,
  DELETE_QUESTION,
  GET_COMMENTS,
  USER_LIKES,
  DELETE_UNIVERSITY,
  SEARCH_POSTS,
  DELTE_EVENT_HOST,
  EDIT_EVENT,
  SEACRH_STORIES,
  EDIT_COMMUNITY,
  SEARCH_COMMUNITY,
  GET_BOOSTS,
  MODERATIONS_POSTS,
  MODERATIONS_USERS,
  MODERATIONS_STORIES,
  MODERATIONS_QUESTIONS,
  MODERATIONS_COMMENTS,
  MODERATIONS_COMMUNITTIES,
  MODERATIONS_EVENTS,
  DELETE_COMMENTS,
  MODERATIONS_POSTS_DELETE,
  MODERATIONS_STORIES_DELETE,
  MODERATIONS_QUESTION_DELETE,
  MODERATIONS_COMMENT_DELETE,
  MODERATIONS_EVENT_DELETE,
  MODERATIONS_USER_DELETE,
  MODERATIONS_COMMUNITY_DELETE,
  MODERATIONS_REPORT_DETAILS,
  STATS_REPORT,
  ACCOUNT_APPROVAL,
  DASH_COUNT,
  DASH_COMMUNITY,
  GET_USERS_POSTS,
  GET_USER_FRIENDS,
  ALL_COMMUNITIES,
  WITHDRAWAL_REQUESTS,
  GET_PROJECTS,
  GET_PROJECT_BY_ID,
  ADD_PROJECT,
  GET_WORKERS,
  ADD_WORKER,
  GET_TASKS,
  PROJECT_ALLOCATE,
  GET_EXPENSES,
  GET_WORKER_PROGRESS,
  GET_WORKER_STATS,
  GET_ALL_CLIENTS,
  GET_WORKER_BY_ID,
  DELETE_WORKER,
  CREATE_TASK,
  GET_TASKS_BY_PROJECT,
  GET_PROJECT_WORKERS,
  GET_WORKERS_PROJECTS,
  UPDATE_PROJECT_STATUS,
  GET_VENDOR,
  CREATE_VENDOR,
  DELETE_VENDOR,
  GET_VENDOR_BY_ID,
  SEND_PROGRESS,
  ADD_PROGRESS_COMMENT,
  ADD_PROGRESS_REPLY,
  ADD_ATTACHMENT_COMMENT,
  GET_ATTACHMENT_COMMENTS,
  GET_WORKER_DETAIL,
  UPDATE_TASK,
  DELETE_TASK,
  EDIT_PROGRESS_COMMENT,
  DELETE_PROGRESS_COMMENT,
  EDIT_ATTACHMENT_COMMENT,
  DELETE_ATTACHMENT_COMMENT,
  CREATE_CLIENT,
  UPDATE_CLIENT,
  GET_CLIENT_DETAIL,
  DELETE_CLIENT,
  GET_DASHBOARD,
  LIKE_COMMENT,
  GET_ORGANIZATION,
  CREATE_MANAGER,
  UPDATE_MANAGER,
  DELETE_MANAGER,
  GET_MANAGERS,
  UPDATE_MANAGER_STATUS,
  REPORTS_WORKER_DATA,
  DELETE_PROJECT,
  GET_SUPER_ADMIN_DASHBOARD,
  GET_ALL_PROJECTS_SUPER_ADMIN,
  GET_ALL_ORGANIZATIONS,
  GET_TOP_ORGANIZATIONS,
  GET_ALL_MANAGERS_SUPER_ADMIN,
  GET_ALL_WORKERS_SUPER_ADMIN,
  GET_ACTIVE_PROJECTS,
  GET_ACTIVE_ORGANIZATIONS,
  GET_SUBSCRIPTION_STATS,
  ASSIGN_CLIENT_TO_PROJECT,
  UPDATE_ORGANIZATION_PLAN,
  ACTIVATE_ORGANIZATION,
  DEACTIVATE_ORGANIZATION,
  DELETE_ORGANIZATION,
  REMOVE_CLIENT_FROM_PROJECT,
  CREATE_ORGANIZATION_MANAGER,
} from "./endpoint";
import axios from 'axios';
import { API_URL } from '../config/api';

export const loginWithEmail = (data) => postRequest(USER_LOGIN, data);
export const forgotPassword = (data) => postRequest(FORGOT_PASSWORD, data);
export const sendOTP = (data) => postRequest(SEND_OTP, data);
export const verifyOTP = (data) => postRequest(VERIFY_OTP, data);
export const resetPassword = (data) => patchRequest(RESET_PASSWORD, data);

export const CreateProject = (data, isFormData = false) => {
  return isFormData
    ? postRequestForm(`${ADD_PROJECT}`, data)
    : postRequest(`${ADD_PROJECT}`, data);
};
export const getProjectsData = (project_id, page, limit, query) => {
  console.log(project_id, page, limit, query, 'service');

  const params = new URLSearchParams();

  if (project_id) params.append('project_id', project_id);
  if (limit) params.append('limit', limit);
  if (page) params.append('page', page);
  if (query) params.append('title', query);

  return getRequest(`${GET_PROJECTS}?${params.toString()}`);
};




export const getProjectById = (id) => getRequest(`${GET_PROJECT_BY_ID}/${id}`);
export const getWorkersData = (id, limit, page, query) => {
  // Build query string with only defined parameters
  const queryParams = new URLSearchParams();

  if (limit) queryParams.append('limit', limit);
  if (page) queryParams.append('page', page);
  if (id) queryParams.append('project_id', id);
  if (query) queryParams.append('title', query);

  const queryString = queryParams.toString();

  return getRequest(`${GET_WORKERS}${queryString ? `?${queryString}` : ''}`);
};

export const CreateWorker = (data) => postRequestForm(`${ADD_WORKER}`, data);
export const UpdateWorker = (id, data) =>
  patchRequestForm(`${ADD_WORKER}/${id}`, data);

export const CreateTask = (data) => postRequestForm(`${CREATE_TASK}`, data);


export const getTasksData = (page = 1, limit, project_id = '', search = '', task_id = '') => {
  const queryParams = new URLSearchParams();

  if (page) queryParams.append('page', page);
  if (limit) queryParams.append('limit', limit);
  if (project_id) queryParams.append('project_id', project_id);
  if (search) queryParams.append('search', search);
  if (task_id) queryParams.append('task_id', task_id);

  const queryString = queryParams.toString();
  return getRequest(`${GET_TASKS}?${queryString}`);
};

export const getClientsData = (page, limit) =>
  getRequest(`${GET_ALL_CLIENTS}/?limit=${limit}&page=${page}`);
export const AllocateProject = (data) =>
  postRequest(`${PROJECT_ALLOCATE}`, data);
export const getExpenses = (
  page,
  limit,
  project_id,
  worker_id,
  search = '',
  expense_id = '',
  {
    startDate = '',
    endDate = '',
    vendor_id = '',
    created_by_role = '',
    user_type = '',
    user_id = '',
    created_by_user = ''
  } = {}
) => {
  let url = `${GET_EXPENSES}/?limit=${limit}&page=${page}`;

  if (project_id) {
    url += `&project_id=${project_id}`;
  }

  if (worker_id) {
    url += `&worker_id=${worker_id}`;
  }

  if (search) {
    url += `&search=${search}`;
  }

  if (expense_id) {
    url += `&expense_id=${expense_id}`;
  }

  if (startDate) url += `&startDate=${startDate}`;
  if (endDate) url += `&endDate=${endDate}`;
  if (vendor_id) url += `&vendor_id=${vendor_id}`;
  // Prefer new backend param created_by_role; fall back to legacy user_type if provided
  if (created_by_role || user_type) url += `&created_by_role=${created_by_role || user_type}`;
  // Backend expects created_by_user for the selected creator id (worker/manager)
  // Keep backward-compat: if caller still sends user_id, map it to created_by_user unless created_by_user is provided
  const creatorId = created_by_user || user_id;
  if (creatorId) url += `&created_by_user=${creatorId}`;

  return getRequest(url);
};

// Expense CRUD
export const createExpense = (formData) => postRequestForm(`${GET_EXPENSES}`, formData);
export const updateExpense = (id, formData) => patchRequestForm(`${GET_EXPENSES}/${id}`, formData);
export const deleteExpense = (id) => deleteRequest(`${GET_EXPENSES}/${id}`);

export const getWorkerProgress = (
  {
    startDate = '',
    endDate = '',
    limit = 10,
    page = 1,
    project_id = '',
    progress_id = '',
    worker_id = '',
  } = {}
) => {
  // Build query string with only defined parameters
  const queryParams = new URLSearchParams();

  if (limit) queryParams.append('limit', limit);
  if (page) queryParams.append('page', page);
  if (startDate) queryParams.append('startDate', startDate);
  if (endDate) queryParams.append('endDate', endDate);
  if (project_id) queryParams.append('project_id', project_id);
  if (worker_id) queryParams.append('worker_id', worker_id);
  if (progress_id) queryParams.append('progress_id', progress_id);

  const queryString = queryParams.toString();

  return getRequest(`${GET_WORKER_PROGRESS}?${queryString}`);
};

export const getWorkerDetail = (id) => getRequest(`${GET_WORKER_DETAIL}/${id}`);

export const getWorkerStats = (id, date) =>
  getRequest(`${GET_WORKER_STATS}?date=${date}&worker_id=${id}`);

export const getWorkerActivityDates = (id) =>
  getRequest(`/worker/activity-dates?worker_id=${id}`);

export const getWorkerHoursReport = async (params) => {
  // Call the reports API with POST and a JSON body
  try {
    const body = {
      worker_ids: Array.isArray(params?.worker_ids) ? params.worker_ids : [],
      start_date: params?.start_date || "",
      end_date: params?.end_date || "",
      project_id: params?.project_id || "",
    };
    return postRequest(REPORTS_WORKER_DATA, body);
  } catch (error) {
    console.error("Error fetching worker hours report:", error);
    throw error;
  }
};
export const deleteWorker = (id) => deleteRequest(`${DELETE_WORKER}/${id}`);
export const getTaskByProject = (projectId, taskId, page, limit) =>
  getRequest(
    `${GET_TASKS_BY_PROJECT}?project_id=${projectId}&taskId=${taskId}&limit=${limit}&page=${page}`
  );
export const deleteTask = (id) => deleteRequest(`${DELETE_TASK}/${id}`);
export const removeProjectAllocation = (data) =>
  deleteRequest(`${PROJECT_ALLOCATE}?project_id=${data.project_id}&user_id=${data.user_id}`);

export const getProjectWorkers = (id) =>
  getRequest(`${GET_PROJECT_WORKERS}?project_id=${id}`);

export const getWorkerProjects = (id) =>
  getRequest(`${GET_WORKERS_PROJECTS}/${id}`);

export const getUpdateProjectStatus = (data) => {
  return patchRequest(`${UPDATE_PROJECT_STATUS}`, data);
};

export const getVendorDetails = (id) => getRequest(`${GET_VENDOR_BY_ID}/${id}`);

//Vendor

export const getVendorData = (id, page, limit, query, vendor_id) =>
  getRequest(
    `${GET_VENDOR}?project_id=${id}&limit=${limit}&page=${page}&title=${query}&vendor_id=${vendor_id}`
  );

export const createVendor = (data) => postRequest(CREATE_VENDOR, data);
export const deleteVendor = (id) => deleteRequest(`${DELETE_VENDOR}/${id}`);
export const updateVendor = (id, data) =>
  patchRequest(`${CREATE_VENDOR}/${id}`, data);

//Mahzen
export const createUniversity = (data) =>
  postRequestForm(`${GET_PROJECTS}`, data);
export const editUniversity = (id, data) =>
  patchRequestForm(`${EDIT_UNIVERSITY}/${id}`, data);
export const deleteUniversity = (data) =>
  patchRequest(`${DELETE_UNIVERSITY}/${data?.id}`);

export const getPostData = (limit, page, data) =>
  getRequest(`${GET_ALL_POSTS}/?&limit=${limit}&page=${page}`, data);
export const getUsersPosts = (url, data) => getRequest(url, data);
export const seacrhPosts = (query, page, limit) =>
  getRequest(`${SEARCH_POSTS}/?query=${query}&page=${page}&limit=${limit}`);
export const getPostTimeData = (data) => getRequest(`${GET_TIME_FOR_POSTS}`);
export const getPostById = (data) =>
  getRequest(`${GET_POST_BY_ID}/${data?.id}`);
export const getUserEvent = (limit, page, search) =>
  getRequest(`${GET_USER_EVENT}/?limit=${limit}&page=${page}&search=${search}`);
export const deleteEvent = (data) =>
  deleteRequest(`${DELETE_EVENT}/${data?.id}`);
export const editEvent = (id, data) =>
  postRequestForm(`${EDIT_EVENT}/${id}`, data);
export const deleteEventHost = (data) =>
  postRequest(`${DELTE_EVENT_HOST}`, data);
export const getEventById = (data) => getRequest(`Event/${data?.id}`);
export const deletePost = (data) => deleteRequest(`${DELETE_POST}/${data?.id}`);
export const getStories = (data) => getRequest(`${GET_STORIES}`);
export const getCommunity = (limit, page) =>
  getRequest(`${ALL_COMMUNITIES}/?limit=${limit}&page=${page}`);
export const getOfficialCommunity = (limit, page) =>
  getRequest(`${OFFICIAL_COMMUNITY}/?limit=${limit}&page=${page}`);
export const getCustomCommunity = (limit, page) =>
  getRequest(`${CUSTOM_COMMUNITY}/?limit=${limit}&page=${page}`);
export const getCommunityById = (data) => getRequest(`community/${data?.id}`);
export const editCommunity = (id, data) =>
  patchRequestForm(`${EDIT_COMMUNITY}/${id}`, data);
export const searchCommunity = (community, page, limit) =>
  getRequest(
    `${SEARCH_COMMUNITY}/?community=${community}&page=${page}&limit=${limit}`
  );

export const getModerationPosts = (limit, page, query) =>
  getRequest(
    `${MODERATIONS_POSTS}/?limit=${limit}&page=${page}&query=${query}`
  );
export const deleteModerationPost = (data) =>
  deleteRequest(`${MODERATIONS_POSTS_DELETE}/${data?.id}`);

export const getModerationUsers = (limit, page, query) =>
  getRequest(
    `${MODERATIONS_USERS}/?limit=${limit}&page=${page}&query=${query}`
  );
export const deleteModerationUser = (data) =>
  deleteRequest(`${MODERATIONS_USER_DELETE}/${data?.id}`);
export const getModerationStories = (limit, page, query) =>
  getRequest(
    `${MODERATIONS_STORIES}/?limit=${limit}&page=${page}&query=${query}`
  );

export const deleteModerationStories = (data) =>
  deleteRequest(`${MODERATIONS_STORIES_DELETE}/${data?.id}`);
export const getModerationQuestions = (limit, page, query) =>
  getRequest(
    `${MODERATIONS_QUESTIONS}/?limit=${limit}&page=${page}&query=${query}`
  );
export const deleteModerationQuestion = (data) =>
  deleteRequest(`${MODERATIONS_QUESTION_DELETE}/${data?.id}`);
export const getModerationComments = (limit, page, query) =>
  getRequest(
    `${MODERATIONS_COMMENTS}/?limit=${limit}&page=${page}&query=${query}`
  );
export const deleteModerationComment = (data) =>
  deleteRequest(`${MODERATIONS_COMMENT_DELETE}/${data?.id}`);
export const getModerationCommunities = (limit, page, query) =>
  getRequest(
    `${MODERATIONS_COMMUNITTIES}/?limit=${limit}&page=${page}&query=${query}`
  );
export const deleteModerationCommunity = (data) =>
  deleteRequest(`${MODERATIONS_COMMUNITY_DELETE}/${data?.id}`);
export const getModerationEvents = (limit, page, query) =>
  getRequest(
    `${MODERATIONS_EVENTS}/?limit=${limit}&page=${page}&query=${query}`
  );
export const deleteModerationEvent = (data) =>
  deleteRequest(`${MODERATIONS_EVENT_DELETE}/${data?.id}`);
export const getUser = (page, limit) =>
  getRequest(`${GET_USER}/?&page=${page}&limit=${limit}`);

// Managers list
export const getManagers = (page = 1, limit = 100, query = "") => {
  const params = new URLSearchParams();
  if (page) params.append('page', page);
  if (limit) params.append('limit', limit);
  if (query) params.append('title', query);
  const qs = params.toString();
  return getRequest(`${GET_MANAGERS}${qs ? `?${qs}` : ''}`);
};
export const boostedPost = (data) => getRequest(`${BOOSTED_POST}`);
export const boostedEvent = (data) => getRequest(`${BOOSTED_EVENT}`);
export const boostedStory = (data) => getRequest(`${BOOSTED_STORIES}`);
export const getWithdrawalRequests = (page, rowsPerPage, searchBy) =>
  getRequest(
    `${WITHDRAWAL_REQUESTS}?page=${page}&limit=${rowsPerPage}&title=${searchBy}`
  );
export const deleteBPost = (data) =>
  deleteRequest(`${DELETE_POST}/${data?.id}`);
export const deleteBEvent = (data) =>
  deleteRequest(`${DELETE_EVENT}/${data?.id}`);
export const deleteStory = (data) =>
  deleteRequest(`${DELETE_STORY}/${data?.id}`);
export const deleteCommunity = (data) =>
  deleteRequest(`${DELETE_COMMUNITY}/${data?.id}`);

//USer module
export const userChangeStatus = (id) =>
  patchRequest(`${USER_CHANGE_STATUS}/${id}`);

export const seacrhUser = (query, page, limit) =>
  getRequest(`${SEACRH_USER}/?query=${query}&page=${page}&limit=${limit}`);
export const getUserProfile = (id) => getRequest(`${GET_USER_PROFILE}/${id}`);
export const updateUserProfile = (data) =>
  patchRequest(`${UPDATE_USER_PROFILE}`, data);
export const deleteQuestion = (data) =>
  deleteRequest(`${DELETE_QUESTION}/${data?.id}`);
export const deleteComment = (data) =>
  deleteRequest(`${DELETE_COMMENTS}/${data?.id}`);
export const getComments = (id) => getRequest(`${GET_COMMENTS}/${id}`);
export const userLikes = (id, duration) =>
  getRequest(`${USER_LIKES}/${id}?duration=${duration}`);
export const seacrhStories = (query, page, limit) =>
  getRequest(`${SEACRH_STORIES}/?query=${query}&page=${page}&limit=${limit}`); export const getBoosts = (type, page, limit, query) =>
    getRequest(
      `${GET_BOOSTS}?type=${type}&page=${page}&limit=${limit}&query=${query}`
    );
export const getReportDetails = (id, type) =>
  getRequest(
    `${MODERATIONS_REPORT_DETAILS}/?entityId=${id}&entityType=${type}`
  );
export const getReportStats = () => getRequest(`${STATS_REPORT}`);
export const accountApproval = (data) =>
  postRequest(`${ACCOUNT_APPROVAL}`, data);
export const getAccountApproval = () => getRequest(`${ACCOUNT_APPROVAL}`);
export const getDashCount = () => getRequest(`${DASH_COUNT}`);
export const getDashCommunity = () => getRequest(`${DASH_COMMUNITY}`);
export const getUserPosts = (id, page, limit) =>
  getRequest(`${GET_USERS_POSTS}/${id}?page=${page}&limit=${limit}`);
export const getFriends = (id) => getRequest(`${GET_USER_FRIENDS}/${id}`);

// export const getContestants=(data)=>getRequest(`${GET_CONTESTANTS}/${data}`);
// export const getRandomUser=(data)=>getRequest(`${GET_RANDOM_USER}/${data}`);
// export const getContestPlayers=(data)=>getRequest(`${GET_CONTEST_PLAYERS}/${data}`);
// export const getLanguage=(data)=>getRequest(GET_LANGUAGE, data);
// export const getJsonFile=(data)=>getRequest(data);
// export const startContest=(user1,user2,params)=>getRequest(`${START_CONTEST}/${user1}/${user2}}`,params);
// export const startRoom=(data)=>getRequest(`${START_ROOM}/${data}`);
// export const deleteUser=(data,params)=>getRequest(`${DELETE_USER}/${data}`,params);
// export const gameWinDetail=(params)=>getRequest(GAME_WIN_DETAIL,params);

export const sendProgressToClient = (data) => postRequest(SEND_PROGRESS, data);

export const addProgressComment = (data) => postRequest(ADD_PROGRESS_COMMENT, data);

export const addAttachmentComment = (data) => postRequest(ADD_ATTACHMENT_COMMENT, data);
export const getAttachmentComments = (attachmentId) =>
  getRequest(`${GET_ATTACHMENT_COMMENTS}/${attachmentId}`);

export const getWorkerDetails = (id) => getRequest(`${GET_WORKER_BY_ID}/${id}`);

export const updateTask = (id, data) => patchRequestForm(`${UPDATE_TASK}/${id}`, data);

export const editProgressComment = (data) => patchRequest(EDIT_PROGRESS_COMMENT, data);
export const deleteProgressComment = (commentId) => deleteRequest(DELETE_PROGRESS_COMMENT, { commentId });

export const editAttachmentComment = (data) => postRequest(EDIT_ATTACHMENT_COMMENT, data);
export const deleteAttachmentComment = (commentId) => deleteRequest(DELETE_ATTACHMENT_COMMENT, { commentId });

export const createClient = (data) => postRequestForm(CREATE_CLIENT, data);
export const updateClient = (id, data) => patchRequestForm(`${UPDATE_CLIENT}/${id}`, data);

export const getClientDetail = (id) => getRequest(`${GET_CLIENT_DETAIL}/${id}`);
export const deleteClient = (id) => deleteRequest(`${DELETE_CLIENT}/${id}`);

export const getAllClients = () => getRequest(GET_ALL_CLIENTS);

export const getDashboardData = () => getRequest(GET_DASHBOARD);

export const likeComment = (data) => postRequest(LIKE_COMMENT, data);

export const getOrganization = () => getRequest(GET_ORGANIZATION);

export const CreateManager = (data) => postRequestForm(CREATE_MANAGER, data);
export const UpdateManager = (id, data) => patchRequestForm(`${UPDATE_MANAGER}/${id}`, data);
export const deleteManager = (id) => deleteRequest(`${DELETE_MANAGER}/${id}`);
export const updateManagerStatus = (managerId, isActive) =>
  patchRequest(UPDATE_MANAGER_STATUS, { manager_id: managerId, is_active: isActive });

export const updateProject = (id, data, isFormData = false) => {
  return isFormData
    ? patchRequestForm(`${ADD_PROJECT}/${id}`, data)
    : patchRequest(`${ADD_PROJECT}/${id}`, data);
};

export const deleteProject = (id) => deleteRequest(`${DELETE_PROJECT}/${id}`);

// Super Admin Dashboard
export const getSuperAdminDashboard = () => getRequest(GET_SUPER_ADMIN_DASHBOARD);
export const getAllProjectsSuperAdmin = (page = 1, limit = 10, { status, search } = {}) => {
  const queryParams = new URLSearchParams();
  if (page) queryParams.append('page', page);
  if (limit) queryParams.append('limit', limit);
  if (status !== undefined && status !== null && status !== '') {
    queryParams.append('status', status);
  }
  if (search) {
    queryParams.append('search', search);
  }
  const queryString = queryParams.toString();
  return getRequest(
    `${GET_ALL_PROJECTS_SUPER_ADMIN}${queryString ? `?${queryString}` : ''}`
  );
};
export const getAllOrganizations = (
  page = 1,
  limit = 10,
  { plan, search, is_active } = {}
) => {
  const queryParams = new URLSearchParams();
  if (page) queryParams.append("page", page);
  if (limit) queryParams.append("limit", limit);
  if (plan && plan !== "all") {
    queryParams.append("plan", plan);
  }
  if (search) {
    queryParams.append("search", search);
  }
  if (is_active !== undefined && is_active !== null && is_active !== "") {
    queryParams.append("is_active", is_active);
  }
  const queryString = queryParams.toString();
  return getRequest(
    `${GET_ALL_ORGANIZATIONS}${queryString ? `?${queryString}` : ""}`
  );
};
export const getTopOrganizations = (limit = 10) => {
  const queryParams = new URLSearchParams();
  if (limit) queryParams.append('limit', limit);
  return getRequest(`${GET_TOP_ORGANIZATIONS}?${queryParams.toString()}`);
};
export const getAllManagersSuperAdmin = (
  page = 1,
  limit = 10,
  { search, is_active } = {}
) => {
  const queryParams = new URLSearchParams();
  if (page) queryParams.append("page", page);
  if (limit) queryParams.append("limit", limit);
  if (search) queryParams.append("search", search);
  if (is_active !== undefined && is_active !== null && is_active !== "") {
    queryParams.append("is_active", is_active);
  }
  const queryString = queryParams.toString();
  return getRequest(
    `${GET_ALL_MANAGERS_SUPER_ADMIN}${queryString ? `?${queryString}` : ""}`
  );
};
export const getAllWorkersSuperAdmin = () => getRequest(GET_ALL_WORKERS_SUPER_ADMIN);
export const getActiveProjects = () => getRequest(GET_ACTIVE_PROJECTS);
export const getActiveOrganizations = () => getRequest(GET_ACTIVE_ORGANIZATIONS);
export const getSubscriptionStats = () => getRequest(GET_SUBSCRIPTION_STATS);

// Super Admin Project Management
export const assignClientToProject = (data) => postRequest(ASSIGN_CLIENT_TO_PROJECT, data);
export const removeClientFromProject = (data) => postRequest(REMOVE_CLIENT_FROM_PROJECT, data);

// Super Admin Organization Management
export const createOrganizationManager = (data) => postRequestForm(CREATE_ORGANIZATION_MANAGER, data);
export const updateOrganizationPlan = (data) => patchRequest(UPDATE_ORGANIZATION_PLAN, data);
export const activateOrganization = (data) => patchRequest(ACTIVATE_ORGANIZATION, data);
export const deactivateOrganization = (data) => patchRequest(DEACTIVATE_ORGANIZATION, data);
export const deleteOrganization = (id) => deleteRequest(`${DELETE_ORGANIZATION}/${id}`);
